module.exports = __webpack_public_path__ + "static/media/carrorama-banner-main-cut.02e1ebb9.webp";